import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";

export async function imageList(
    owner_id: string,
    query?: QueryType
) {

    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `admin/game/${owner_id}/image/list${queryString}`
    );
}

export async function imageShow(
    image_id: string,
    query?: QueryType
) {

    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `admin/game/image/${image_id}/show${queryString}`
    );
}

export async function imageCreate(
    owner_id: string,
    payload: { file: string; status: string }
) {
    return await clientAxios.post(
        `admin/game/${owner_id}/image/create`,
        payload
    );
}

export async function imagePatch(
    image_id: string,
    file: string
) {
    return await clientAxios.patch(
        `admin/game/image/${image_id}/patch`,
        { file }
    );
}

export async function imageUpdate(
    image_id: string,
    file: string
) {
    return await clientAxios.put(
        `admin/game/image/${image_id}/update`,
        { file }
    );
}

export async function imageDelete(
    image_id: string,
) {
    return await clientAxios.del(
        `admin/game/image/${image_id}/delete`,
    );
}
